export const AUTH_ENDPOINTS_URLS = {
  register: "auth/register",
  login: "auth/login",
  checkPhoneExists: "auth/check-phone-exists",
  validateRefId: "auth/validate-ref-id",
};

export const AUTH_TAGS = {
  auth: "auth",
};
